
import { AfterViewChecked, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";

import { Subscription } from "rxjs";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { AppointmentService } from "../../services/Sappointment.service";
import { GeneralUrlService } from "../../services/SgeneralUrl.service";
import { ConfirmRemarksComponent } from "../patient-appointment/confirm-remarks/confirm-remarks.component";
import { Configuration } from "projects/lib/medcare-core-lib/src/lib/shared/Configuration";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { PatientService } from "projects/lib/medcare-core-lib/src/lib/services/patient.service";
import { SearchService } from "projects/lib/medcare-core-lib/src/lib/services/search.service";
import { thEnConverterService } from "projects/lib/medcare-core-lib/src/lib/services/thEnConverterService";
import { Langauge } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";

@Component({
  selector: "app-patient-reschedule-list",
  templateUrl: "./patient-reschedule-list.component.html",
  styleUrls: ["./patient-reschedule-list.component.scss"],
})
export class PatientRescheduleListComponent implements OnInit, OnDestroy{
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: any = OPD_CONST.reschuleList;
  dataSource = new MatTableDataSource<any>();
  public appointmentList: any = [];
  private subscriptionList = new Subscription();
  totalDataLength: number = 0;
  pageSize: number = 0;
  paginatorOptions: any;
  pageIndex: number = 0;
  offsetData: number = 0;
  langaugeValue:string="";
  searchAppt: {
    fromDate: any;
    toDate: any;
    mrn: any;
    doctor: any;
    dept: any;
    apptype: any;
    pname: any;
  } = {
    fromDate: "",
    toDate: "",
    mrn: "",
    doctor: "",
    dept: "",
    apptype: "",
    pname: "",
  };
  searchList: any[];


  statusList: any = {
    all: [],
    pending: [],
    booked: [],
    arrived: [],
    cancelled: [],
    noshow: [],
  };
  constructor(
    private httpService: AppBaseService,
    private searchService: SearchService,
    private patientService: PatientService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    private langService: MultiLanguageService,
    private appoinmentService: AppointmentService,
    public generalApiService: GeneralUrlService,
    private thConvertService:thEnConverterService
  ) {}

  ngOnInit(): void {
    this.langaugeValue=localStorage.getItem("lan");
    this.searchList = this.appoinmentService.getappointmentRescheduleSearchList(this);
    this.pageSize = Configuration.PAGINATOR_DEFAULT;
    this.paginatorOptions = Configuration.PAGINATOR_OPTIONS;
    this.searchAppt.fromDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.searchAppt.toDate = new Date(new Date().setHours(23, 59, 0, 0));
    this.searchService.setSearch(this.searchList);

    this.subscriptionList.add(
      this.searchService.getResult.subscribe((res) => {
        this.serachStructureURL(res);
      })
    );
    let quickSearch = this.searchService.getElasticSearch.subscribe(quickSearch => {
      let result = {MRN: quickSearch};
      this.serachStructureURL(result);
    });
    this.subscriptionList.add(quickSearch);
    this.getAppointmentList();

    this.langService.changeFooterLaber().then((val) => {
      if(this.paginator){
      this.paginator._intl.itemsPerPageLabel = val;
      }
    });
  }

  /**
   *set search ist
   *
   * @param {*} res
   * @memberof PatientAppointmentListComponent
   */
  serachStructureURL(res) {
    this.searchAppt.fromDate = res.daterange && res.daterange.startDate
      ? res.daterange.startDate.$d
      : "";
    if (res.daterange && res.daterange.endDate) {
      this.searchAppt.toDate = res.daterange.endDate.$d;
      var today = this.epochConverter(this.searchAppt.fromDate);
      var sameDay = this.epochConverter(this.searchAppt.toDate);
      if (today == sameDay)
        this.searchAppt.toDate = new Date(
          res.daterange.endDate.$d.setHours(23, 59, 0, 0)
        );
    } else {
      this.searchAppt.toDate = null;
    }
    this.searchAppt.apptype = res.AppointmentType
      ? res.AppointmentType.code
      : "";
    this.searchAppt.dept = res.Department ? res.Department.code : "";
    this.searchAppt.doctor = res.Doctor ? res.Doctor.code : "";
    this.searchAppt.mrn = res.MRN;
    this.searchAppt.pname = res.PatientName? res.PatientName : "";
    this.getAppointmentList();
  }
  /*Destroy method
   *
   * @memberof PatientRegistrationComponent
   */
  ngOnDestroy() {
    this.searchService.setSearch([]);
    this.subscriptionList.unsubscribe();
  }
  /**
   *Get Appointment List Data
   *
   * @memberof PatientAppointmentListComponent
   */
  public getAppointmentList() {
    var fromDate = this.searchAppt.fromDate
      ? this.epochConverter(this.searchAppt.fromDate)
      : "";
    var toDate = this.searchAppt.toDate
      ? this.epochConverter(this.searchAppt.toDate)
      : "";
    var payload = this.appoinmentService.getrescheuleReqPayload(
      this,
      fromDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(fromDate): fromDate,
      toDate && this.langaugeValue == Langauge.TH ? this.thConvertService.convertEpochThaiToEnglish(toDate): toDate,
    );
    this.appointmentList = [];
    this.statusList = {
      all: [],
      pending: [],
      booked: [],
      arrived: [],
      cancelled: [],
      noshow: [],
    };
    this.httpService.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.httpService.getResource(payload).subscribe((res) => {
        if (res != null) {
          this.appointmentList = this.appoinmentService.getappoitmentList(
            res,
            this
          );
          this.dataSource = new MatTableDataSource<any>(this.appointmentList);
        }
      })
    );
  }
  /**
   *converter Method
   *
   * @param {*} strDate
   * @return {*}
   * @memberof PatientAppointmentListComponent
   */
  epochConverter(strDate) {
    if (strDate) {
      const datum = Date.parse(strDate);
      const epoch = datum / 1000;
      return epoch;
    } else return "";
  }
  /**
   *Cancel and Reschedule calling method
   *
   * @param {*} type
   * @memberof PatientAppointmentListComponent
   */
  cancelAppt(type, eachAppt) {
    var currentTime = Number(new Date().getTime() / 1000);
    var appointmenttime = Number(this.epochConverter(eachAppt.appointmentDate));
    if (appointmenttime < currentTime) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.validation"),
        this.langService.get("AppointmentListPage.appoinmentcannotcancel"),
        {
          duration: 3000,
        }
      );
    } else {
      if (type == OPD_CONST.appointmentListStatic.reschedule) {
        var patientInfo: any;
        if (eachAppt.app.patientType.code == OPD_CONST.appoinmentRef.temp) {
          patientInfo = {
            type: eachAppt.app.patientType.code,
            MRN: eachAppt.patientMrn,
            patientid: eachAppt.app.temporaryPatient.id,
            id: eachAppt.id,
            doctorCode: eachAppt.app.doctor ? eachAppt.app.doctor.code : "",
            departmentCode: eachAppt.app.specialty[0].coding[0].code,
            appointmentType: eachAppt.bookingTypeCode
              ? eachAppt.bookingTypeCode
              : "",
            remarks: eachAppt.comment,
            splReq: eachAppt.specialRequirements
              ? eachAppt.specialRequirements
              : null,
              isReschedule:true
          };
          localStorage.setItem(
            OPD_CONST.appoinmentRef.aptResData,
            JSON.stringify(patientInfo)
          );
          this.router.navigate([OPD_API_URL.OPD_APPOINTMENT_NAVIGATE]);
        } else {
          patientInfo = {
            type: eachAppt.app.patientType.code,
            MRN: eachAppt.patientMrn,
            patientid: eachAppt.app.patient.id,
            id: eachAppt.id,
            doctorCode: eachAppt.app.doctor ? eachAppt.app.doctor.code : "",
            departmentCode: eachAppt.app.specialty[0].coding[0].code,
            appointmentType: eachAppt.bookingTypeCode
              ? eachAppt.bookingTypeCode
              : "",
            remarks: eachAppt.comment,
            splReq: eachAppt.specialRequirements
              ? eachAppt.specialRequirements
              : null,
          };
          localStorage.setItem(
            OPD_CONST.appoinmentRef.aptResData,
            JSON.stringify(patientInfo)
          );
          this.router.navigate([OPD_API_URL.OPD_APPOINTMENT_NAVIGATE]);
        }
      } else {
        const dialogRef = this.dialog.open(ConfirmRemarksComponent, {
          width: "20%",
          data: { dialogName: type, pageName:"PatientRescheduleList"}
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            let reqpaylad: any;

            if (result.action == "yes") {
              reqpaylad = [
                {
                  id: eachAppt.id,
                  status: "CANCELLED",
                  remarks: result.remarks ? result.remarks : "",
                  reason: result.reason
                    ? this.langService.createObjectList(result.reason[0])
                    : "",
                },
              ];
              this.subscriptionList.add(
                this.generalApiService
                  .putTypeApi(
                    OPD_API_URL.OPD_SERVICE,
                    OPD_API_URL.OPD_APPOINTMENT_STATUS,
                    reqpaylad
                  )
                  .subscribe((response: any) => {
                    if (response) {
                      this.snackBar.open(
                        this.langService.get("CommonAppoinment.success"),
                        this.langService.get("AppointmentListPage.appointmenthasbeencancel"),
                        {
                          duration: 3000,
                        }
                      );
                    }
                  })
              );
            }
          })
        );
      }
    }
  }
  /**
   *list next event
   *
   * @param {*} event
   * @memberof PatientAppointmentListComponent
   */
  getNext(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex ;
    this.offsetData = event.pageIndex * event.pageSize;
    this.getAppointmentList();
  }
  getStatusColor(status: string): { text: string; backgroundColor: string } {
    let style: { text: string; backgroundColor: string } = {
      text: "",
      backgroundColor: "",
    };
    switch (status) {
      case "Booked":
        style.text = "Booked";
        style.backgroundColor = "#ffd88e";
        break;
      case "Arrived":
        style.text = "Arrived";
        style.backgroundColor = "#bef0bb";
        break;
      case "Cancelled":
        style.text = "Cancelled";
        style.backgroundColor = "#ffcdcd";
        break;
          case "Rescheduled":
          style.text = "Rescheduled";
          style.backgroundColor = "#649d9d";
          break;
        case "No Show":
          style.text = "No Show";
          style.backgroundColor = "#fdbd92";
          break;
        case "Payment Received":
          style.text = "Payment Received";
          style.backgroundColor = "#5f5fcb";
          break;
      default:
        break;
    }
  
    return style;
  }
   
  refreshSearch() {
     this.offsetData = 0;
    this.pageSize = 10;
    this.getAppointmentList();
  }
}
